// test2004
(2004 && 0);
